package br.com.htms.inspeccaocampo.web

import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.mutableStateOf
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.unit.Density
import androidx.compose.ui.window.CanvasBasedWindow
import br.com.htms.inspeccaocampo.platform.PlatformFiles
import br.com.htms.inspeccaocampo.platform.rotuloPortalDoEndereco
import br.com.htms.inspeccaocampo.ui.SharedAppRoot
import kotlinx.browser.window
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.launch
import kotlinx.coroutines.withTimeoutOrNull
import org.jetbrains.skiko.wasm.onWasmReady

/**
 * Entrada da versão web — não altera Android/iOS.
 * Aquece IndexedDB com timeout curto e abre a UI; leituras on-demand cobrem miss.
 */
@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    val zoom = mutableStateOf(lerZoomWeb())
    window.addEventListener("icd-zoom", { zoom.value = lerZoomWeb() })
    onWasmReady {
        GlobalScope.launch {
            runCatching {
                withTimeoutOrNull(4_000) { PlatformFiles.warmUp() }
            }.onFailure { println("PlatformFiles.warmUp failed: ${it.message}") }
            try {
                CanvasBasedWindow(
                    canvasElementId = "ComposeTarget",
                    title = rotuloPortalDoEndereco() ?: "Portal QSSMA"
                ) {
                    val base = LocalDensity.current
                    CompositionLocalProvider(
                        LocalDensity provides Density(base.density * zoom.value, base.fontScale)
                    ) {
                        SharedAppRoot()
                    }
                }
            } catch (t: Throwable) {
                println("CanvasBasedWindow failed: ${t.message}")
                reportWebBootFailure(t.message ?: t.toString())
            }
        }
    }
}

private fun lerZoomWeb(): Float {
    val v: dynamic = window.asDynamic().__ICD_ZOOM
    return if (jsTypeOf(v) == "number") (v as Number).toFloat().coerceIn(0.5f, 2.5f) else 1f
}
